var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1997_10857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 12.5001C3.38945 12.5001 3.00116 12.5001 2.69488 12.3732C2.2865 12.2041 1.96204 11.8796 1.79288 11.4712C1.66602 11.1649 1.66602 10.7767 1.66602 10.0001V4.33341C1.66602 3.39999 1.66602 2.93328 1.84767 2.57676C2.00746 2.26316 2.26243 2.00819 2.57603 1.8484C2.93255 1.66675 3.39926 1.66675 4.33268 1.66675H9.99935C10.7759 1.66675 11.1642 1.66675 11.4705 1.79362C11.8789 1.96277 12.2033 2.28723 12.3725 2.69561C12.4993 3.00189 12.4993 3.39018 12.4993 4.16675M10.166 18.3334H15.666C16.5994 18.3334 17.0661 18.3334 17.4227 18.1518C17.7363 17.992 17.9912 17.737 18.151 17.4234C18.3327 17.0669 18.3327 16.6002 18.3327 15.6667V10.1667C18.3327 9.23333 18.3327 8.76662 18.151 8.4101C17.9912 8.09649 17.7363 7.84153 17.4227 7.68174C17.0661 7.50008 16.5994 7.50008 15.666 7.50008H10.166C9.23259 7.50008 8.76588 7.50008 8.40936 7.68174C8.09576 7.84153 7.84079 8.09649 7.681 8.4101C7.49935 8.76662 7.49935 9.23333 7.49935 10.1667V15.6667C7.49935 16.6002 7.49935 17.0669 7.681 17.4234C7.84079 17.737 8.09576 17.992 8.40936 18.1518C8.76588 18.3334 9.23259 18.3334 10.166 18.3334Z",
    stroke: "#666666",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1997_10857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.c5fa127ca523969fd9f2bf263a17e34a.svg";
export { ForwardRef as ReactComponent };